export enum EnumAcrescimoDesconto{
    DESCONTO = 'Desconto',
    ACRESCIMO = 'Acrescimo'
}